"use client"

import { ActionsSectionDto } from "api"
import { useEffect, useRef } from "react"
import ActionCard from "./ActionCard"
import {
  ActionsInner,
  ActionsSectionWrap,
  CardsRow,
  Eyebrow,
  Headline,
  SectionHeader,
} from "./actionsSection.styled"
import { CardDisplayOn } from "./deviceCards"

type Props = { data?: ActionsSectionDto | null }

const ActionsSection = ({ data }: Props) => {
  const rowRef = useRef<HTMLDivElement>(null)

  // Reveal the card stagger once the row scrolls into view (one-shot).
  useEffect(() => {
    const el = rowRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          el.classList.add("in-view")
          observer.disconnect()
        }
      },
      { threshold: 0.2 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const cards = [...(data?.cards ?? [])].sort(
    (a, b) => a.cardOrder - b.cardOrder
  )
  if (cards.length === 0) return null

  const cardsCountDesktop = cards.filter(
    (card) => card.displayOn !== CardDisplayOn.Mobile
  ).length
  const cardsCountMobile = cards.filter(
    (card) => card.displayOn !== CardDisplayOn.Desktop
  ).length

  return (
    <ActionsSectionWrap
      dir="rtl"
      aria-label={data?.sectionHeadline || data?.sectionLabel || "פעולות"}
    >
      <ActionsInner>
        <SectionHeader>
          {data?.sectionLabel && (
            <Eyebrow dir="auto">{data.sectionLabel}</Eyebrow>
          )}
          {data?.sectionHeadline && (
            <Headline dir="auto">{data.sectionHeadline}</Headline>
          )}
        </SectionHeader>
        <CardsRow
          ref={rowRef}
          $cardsCountDesktop={cardsCountDesktop}
          $cardsCountMobile={cardsCountMobile}
        >
          {cards.map((card) => (
            <ActionCard key={card.id} card={card} />
          ))}
        </CardsRow>
      </ActionsInner>
    </ActionsSectionWrap>
  )
}

export default ActionsSection
